module.exports = __webpack_public_path__ + "static/media/btc.c6440537.svg";